import React, {useState, useEffect} from 'react';
import { styled } from "@mui/material/styles";
import {Grid, Button} from '@mui/material';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';

const FeaturedItem = ({item, currentView}) =>{  
  
 // console.log(item)
    let type = (item.original_name  == null) ? 'movie' : 'tv';
    let firstDate = new Date(type == 'tv'? item.first_air_date:item.release_date);
    let backgroundImage = item.backdrop_path !=null ? item.backdrop_path : item.poster_path;
    let genres=[]
    for(let i in item.genres){genres.push(item.genres[i].name)}
    const FeaturedDiv = styled("div")(({ theme }) => ({
        display: "flex",
        width:"100%",
        height:"85vh",
        backgroundSize:"cover",
        backgroundPosition:"top",
        backgroundImage:`url(https://image.tmdb.org/t/p/original${backgroundImage})`,
      }));
      const FeaturedVerticalDiv = styled("div")(({ theme }) => ({
        width:"inherit",
        height:"inherit",
        background:"linear-gradient(to top, #111 10%, transparent 90%)"
      }));
      const FeaturedHorizontalDiv = styled("div")(({ theme }) => ({
        display:"flex",
        flexWrap:"wrap",
        alignContent:"center",
        maxWidth:"100%",
        width:"100%",
        height:"inherit",
        background:"linear-gradient(to right, #11111175 40%, transparent 60%)"
      }));
      const FeaturedInfo = styled("div")(({ theme }) => ({
        fontSize:"1.2rem",
        fontWeight:"bold",
        color:"#fff",
        marginLeft:"3%",
        marginTop:"-3rem"
      }));


    return(
      <>
        <FeaturedDiv> 
            <FeaturedVerticalDiv>
                <FeaturedHorizontalDiv>
                    <FeaturedInfo>
                        <h2 style={{color:"#fff", fontSize:"3.75rem",}}>{type=="movie"? item.title : item.original_language == 'zh' || item.original_language == 'ch'|| item.original_language == 'ko'|| item.original_language == 'ja'? item.name: item.original_name}</h2>
                        <div style={{display:"inline-block", color:"#46d369", marginRight:"1rem"}}>{item.vote_average} </div>
                        <div style={{display:"inline-block",marginRight:"1rem"}}><span style={{color:"#cccccc"}}>|</span><span style={{marginLeft:"1rem"}}>{firstDate.getFullYear()}</span></div>
                        {type == 'tv'? <div style={{display:"inline-block",marginRight:"1rem"}}><span style={{color:"#cccccc", paddingRight:"1rem"}}>|</span> {item.number_of_seasons} temporada{item.number_of_seasons !=1?'s':''}</div>:''}
                        <div style={{marginTop:"1rem", fontSize:"1.2rem", color:"#999", maxWidth:"45%", overflow:"hidden", display:"-webkit-box",WebkitLineClamp:"6", WebkitBoxOrient:"vertical"}}>{item.overview}</div>
                        <div style={{marginTop:"1rem", fontSize:"0.9rem", }}><b>Gêneros: </b>{genres.join(', ')}</div>
                       {currentView == 'home'?<Link to={`/fullDescription/${type}/${item.id}`} style={{textDecoration:"none"}}><Button variant="contained" size="large" color="error" style={{marginTop:"3%",}}>Assistir</Button></Link>:<></>} 
                    </FeaturedInfo>
                </FeaturedHorizontalDiv>
            </FeaturedVerticalDiv>
        </FeaturedDiv>
        </>
    );
}

export default FeaturedItem;